<div class="">
    <mat-dialog-content class=""> 
            <button (click)="closeDialogue()" class="m-show m-back-arrow" type="button"><img src="assets/img/m-back-arrow-dark.svg" alt=""></button>
        <div class="font-14 heading">
            <h4>{{ data?.message }}<span><button class="closeButton m-hide" (click)="closeDialogue()">X</button></span></h4>
        </div>
        <div class="assessment_py-10 font-8">
            {{ data?.message2 }}
        </div>
        <form [formGroup]="otpForm"> 
            <div class="form-group phn-input">
        <input class="form-control" type="text" formControlName="phone" [readonly]="data.phone?true:false" placeholder="Phone Number" phone-number  >
     </div>
     <button class="btn btn-primary btn-block" type="button" (click)="sendOtp()">SEND OTP</button>
        <div class="assessment_pt-10">
        <button class="btn btn-block" type="button" (click)="passwordLogin()">LOGIN WITH PASSWORD</button>
    </div>
</form>
    </mat-dialog-content>
    
</div>